import * as React from 'react';
import Spinner from '@shorelight/ui-common-components/cjs/components/progress/Spinner';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';

const styles = () => ({
  spinnerContainer: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

interface LoadingIndicatorProps extends WithStyles<typeof styles> {}
const LoadingIndicator = (props: LoadingIndicatorProps) => (
  <div className={props.classes.spinnerContainer}>
    <Spinner size="medium" />
  </div>
);

export default withStyles(styles)(LoadingIndicator);
